import "./emptySpin.scss";
import { type GetProps, Spin } from "antd";

interface EmptySpinProps extends GetProps<typeof Spin> {
    readonly tip: React.ReactNode;
}

/** Empty antd spinner that just displays a message. */
export const EmptySpin = ({ tip, wrapperClassName, ...props }: Readonly<EmptySpinProps>) => (
    <Spin tip={tip} {...props} wrapperClassName={`vyne-empty-spin ${wrapperClassName}`}>
        <div style={{ display: "flex", justifyContent: "space-between", minHeight: "100px", width: "100%" }} />
    </Spin>
);
